<!-- @format -->

<div class="cdialog overlay" style="width: 300px; min-height: 150px">
  <div class="dialogHeader">
    <div mat-dialog-title>{{_common.numParticipants_edit}}</div>

    <div class="spacer"></div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content class="max-height">
    <div class="max-scroll m-2">
      <form [formGroup]="form">
        <div class="text-center space-y-4">
          <!-- <div class="cardHeader"></div> -->
          <div class="space-y-2 mt-2 text-center">
            <div>
              <app-form-field class="w-full">
                <input matInput formControlName="numParticipants" type="number" min="0" step="1"
                  oninput="validity.valid||(value='')" />
              </app-form-field>
            </div>
            <div *ngIf="form.controls['numParticipants'].invalid && form.controls['numParticipants'].touched"
              class="text-red-500">
              {{_common.numParticipants_edit_error}}
            </div>
          </div>
        </div>
      </form>
      <div class="flex justify-center mt-4 mb-2">
        <button class="app-btn w-full" (click)="save()" color="primary">
          {{_common.confirm}}
        </button>
      </div>
    </div>
  </mat-dialog-content>
  <!-- <div class="dialogBar">
    <div class="spacer"></div>


  </div> -->
</div>